import { awaitRequestJson, authPost } from '@/api/helpers'
import { SnowflakeConfigReponse, SnowflakeQueryOptions, VersionIdParam } from '@/types'

export async function getSnowflakeDatabases (params: Omit<SnowflakeQueryOptions, 'schema' | 'database'>): Promise<SnowflakeConfigReponse[]> {
  // Todo: handle snowflake response
  return awaitRequestJson(authPost('snowflake/databases', params))
}

export async function getSnowflakeSchemas (params: Omit<SnowflakeQueryOptions, 'schema'>): Promise<SnowflakeConfigReponse[]> {
  // Todo: handle snowflake response
  return awaitRequestJson(authPost('snowflake/schemas', params))
}

export async function getSnowflakeTables (params: SnowflakeQueryOptions): Promise<SnowflakeConfigReponse[]> {
  // Todo: handle snowflake response
  return awaitRequestJson(authPost('snowflake/tables', params))
}

export async function getSnowflakeViews (params: SnowflakeQueryOptions): Promise<SnowflakeConfigReponse[]> {
  // Todo: handle snowflake response
  return awaitRequestJson(authPost('snowflake/views', params))
}

export function getSnowflakeData (payload: SnowflakeQueryOptions, params: Partial<VersionIdParam> = {}): Promise<any> {
  // Todo: handle response
  return awaitRequestJson<{ [column: string]: string }[]>(authPost('snowflake/data', payload, params))
}
